export default "__VITE_ASSET__da80d203__"